<template>
  <!-- Under maintenance-->
  <div class="p-5 w-100 text-center">
        <h2 class="mb-1">
          У Вас нет данных 🛠
        </h2>

        <p class="mb-3">
          Начните создавать обьекты прямо сейчас !
        </p>

        <!-- img -->
        <b-img
                width="300px"
                :src="downImg"
                alt="Under maintenance page"
        />
  </div>
<!-- / Under maintenance-->
</template>

<script>
/* eslint-disable global-require */
import { BImg, } from 'bootstrap-vue'

export default {
  components: {
    BImg,
  },
  setup () {

    const downImg = require('@/assets/images/pages/under-maintenance.svg')

    return {
      downImg
    }
  }
}
</script>

